<template>
  <div>
    <Row style="width: 100%;margin-top:110px">
      <Col span="12" style="margin-top: 80px;margin-left: 130px;">
            <Row style="width: 100%;" >
                <Col span="24"> 
                <p style="font-size: 22px; color: rgb(28, 114, 220); margin-left: -380px; font-weight: 600;">公司介绍
                 </p></Col></Row></br></br>
                 <Row style="    line-height: 30px;text-indent: 38px;font-size: 18px;width: 89%;float: left;text-align: justify;letter-spacing: 5px;">
                   <p >北龙泽达（北京）数据科技有限公司（简称“北龙泽达”），是一家高新技术企业，
                        依托大数据分析与计算技术国家地方联合工程实验室的优秀资源，以国家级数据中心服务经
                        验的积累为基础，以大数据的产业化应用为主要业务方向，不断推出云计算、云存储、大数据风控等迭代产品。</p></br>
                <p>经过前期的资本积累，北龙泽达迎来了技术全面拓展的机遇。在声学领域，北龙泽达将致力于为用户提供专业一流的解决方案， 实行交钥匙工程。</p></br>
                <p >高声强混响室与行波管主要应用于航空航天领域，进行强噪声环境模拟，考核试件对声载荷的适应性。
                    北龙泽达拥有绝对专业的高声强实验室建设能力，为用户打造可靠专业的高声强试验系统。</p></br>

                <p>消声室、普通混响室、隔声室等声学实验室在航空航天、轨道交通、汽车、家电、船舶、兵器、电子、通信、医疗等领域均有普遍应用，
                    是进行声学相关测试的重要设施。北龙泽达在现有基础上，积极推广核心新产品新技术的应用，大大改善消声室的声学性能，为实验室
                    的高精度提供有力的保证。</p></br>

                <p>北龙泽达在消声降噪工程方面推行切实有效的解决方案，为用户实现达标的声环境。</p>

            </Row>
            
      </Col>
       <Col span="8" style="margin-top: 130px;">
            <img :src="img" width="80%">
      </Col>
    </Row>





   <!-- 2 -->
    <Row :gutter="30" style="display: flex;justify-content: center;margin-top:100px;">
      <Col span="8" class="title">
          <img :src="img2" width="70%">
      </Col>
      <Col span="8" style="margin-top: 80px;text-align: left; line-height: 40px; ">
          <Row ><p style="font-size:22px;color:rgb(28, 114, 220);font-weight: 600;">高声强试验系统</p><span style="margin-top: 50px;font-size:14px;color:grey">HIGH SOUND INTENSITY TEST SYSTEM</span></Row>
         
          <Row style="margin-top: 50px;font-size:18px;"><span >高声强混响室与行波管主要应用于航空航天领域，进行强噪声环境模拟，考核试件对声载荷的适应性。</span>
          </Row>
          
      </Col>
    </Row>

     <Row style="display: flex;justify-content: center;margin-top:100px;margin-right: 200px;">
     
      <Col span="8" style="margin-top: 80px;text-align: right; line-height: 40px;">
       <Row ><p style="font-size:22px;color:rgb(28, 114, 220);font-weight: 600;">声学实验室系统</p><span style="margin-top: 50px;font-size:14px;color:grey">ACOUSTIC LABORATORY SYSTEM</span></Row>
         
          
          <Row style="margin-top: 50px;font-size:18px;"><p style="text-align: right;">声学试验一站式服务项目包括消声室、混响室、听音室、隔音量测试室。</p>
          </Row> 
          
      </Col>
       <Col span="8" class="title" style="margin-left: 70px;">
          <img :src="img3" width="75%">
      </Col>
    </Row>

    <Row style="display: flex;justify-content: center;margin-top:100px;margin-bottom:100px">
      <Col span="8" class="title">
          <img :src="img4" width="70%">
      </Col>
      <Col span="8" style="margin-top: 80px;text-align: left; line-height: 30px;">
      <Row ><p style="font-size:22px;color:rgb(28, 114, 220);font-weight: 600;">消声降噪工程</p><span style="margin-top: 50px;font-size:14px;color:grey">NOISE ELIMINATION AND NOISE REDUCTION PROJECT</span></Row>
        
          
          <Row style="margin-top: 50px;font-size:18px;"><span >专业的消声解决方案广泛应用于隔声房/罩，隔声门/窗，隔声屏障，消声器，空间吸声体，隔声降噪工程 从建筑声学方案设计,到经验丰富的施工资讯团队,让我们为您的听觉护航。</span>
          </Row>
          
      </Col>
    </Row>
    
  </div>
 
</template>
<script>
export default {
  data() {
    return {
      info:23923,
      bid:115486,
      money:16745305.75,
      noticeList:[],
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      img: "../../../../static/officeImg/acoustics/02.webp",
      img2:"../../../../static/officeImg/acoustics/gaoshengqiang.webp",
      img3:"../../../../static/officeImg/acoustics/shengxue.webp",
      img4:"../../../../static/officeImg/acoustics/xiaosheng.webp",
    };
  },
   filters: {
        formatDate(time) {
            var date = new Date(time);
            return formatDate(date, "yyyy-MM-dd hh:mm");
        }
  },
  mounted() {
    this.loadData();
    //千位分割符
     this.money= this.toThousands(this.money,2);
  },
  methods: {
    loadData: function() {
    },
    Goto: function(type,id){
         switch (type) {
          case 'C01':
            {
              this.$router.push({ name: 'detail', query: { detailId: id}})
            }
            break;
          case 'C02':
            {
                this.$router.push({ name: 'detail2', query: { detailId: id}})
            }
            break;
          case 'C03':
            {
                this.$router.push({ name: 'detail1', query: { detailId: id}})
            }
            break;
         case 'C04':
            {
                this.$router.push({ name: 'detail3', query: { detailId: id}})
            }
            break;
            default:
            break;
        }
    },
    more: function() {
      this.$router.push({ path: "/item" });
    },
     //千位分割符
      toThousands: function(num,n, separator) {
     let parts;
     num = num + "";
     // 判断是否为数字
     if (!isNaN(parseFloat(num)) && isFinite(num)) {
    let nx;
         nx=Math.pow(10,n);

         num = (Math.round(num* nx) / nx).toFixed(n);


         parts = num.split('.');
         parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (separator || ','));

         return parts.join('.');
     }
     return NaN;
}
  }
};
</script>
<style scoped>
.backImg {
  background-color: white;
  width: 100%;
  font-size: 25px;
  text-align: center;
  line-height: 30px;
  color: red;
  margin-top: 0px;
  margin-left: 0px;
}
.ImgLocal{
  position:relative;
  left:180px;
  margin-top:40px;
}
.FontLocal{
  margin-top:60px;
}
.title {
    text-align: center;
    color: rgb(0, 0, 0);
    font-size: 23px;
    line-height: 40px;
    padding: 1% 0px;
}
.li2 {
  width: 50%;
  font-size: 15px;
  margin-top: 6px;
}
.numInfo {
  background: white;
  font-size: larger;
  font-family: 微软雅黑;
  height: 100px;
  padding: 20px;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
}
.baseCard{
  background: white;
  font-family: 微软雅黑;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
  
}
.cardTitle{
  text-align: left;
  font-weight:540 !important;
  color: orange;
}

.li3 {
  width: 43%;
  font-size: 12px;
}
.icon-shuxian{
 font-size: 20px;
}
.shuxian{
  display:inline-block;
  width:4px;
  height: 22px;
  background: orange;
}
.icon-gengduo{
  color: orange;
}
.gengduo{
  font-family: 微软雅黑;
  color: rgb(120, 122, 123);
  font-size: 15px;
}
.wailian{
  font-size: 15px;
  font-weight:540;
  color:#787a7b;
}
</style>



// WEBPACK FOOTER //
// src/views/voiceData/voiceData.vue